import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Dog Days of Summer",
  date: new Date(2025, 7, 17),
  img: "/img/baby-sax.jpeg",
  tracks: [
    {
      title: "Calibration Citation",
      src: "/songs/2025-08-17/calibration_citation.mp3",
      duration: 536.256,
    },
    {
      title: "Continuation Implication",
      src: "/songs/2025-08-17/continuation_implication.mp3",
      duration: 560.616,
    },
    {
      title: "Baby's First Steps",
      src: "/songs/2025-08-17/babys_first_steps.mp3",
      duration: 772.968,
    },
    {
      title: "Dublin Down",
      src: "/songs/2025-08-17/dublin_down.mp3",
      duration: 821.76,
    },
    {
      title: "Cause & Effect",
      src: "/songs/2025-08-17/cause_and_effect.mp3",
      duration: 1005,
    },
    {
      title: "The Naked Truth",
      src: "/songs/2025-08-17/the_naked_truth.mp3",
      duration: 1443.504,
    },
    {
      title: "Layover Hangover",
      src: "/songs/2025-08-17/layover_hangover.mp3",
      duration: 1728.96,
    },
    {
      title: "Overdub Club",
      src: "/songs/2025-08-17/overdub_club.mp3",
      duration: 972.912,
    },
    {
      title: "Burner Phone Syndrome",
      src: "/songs/2025-08-17/burner_phone_syndrome.mp3",
      duration: 1798.8,
    },
  ],
};
export default album;
